import React, {useState, useEffect, useRef, useMemo} from 'react';
import Moment from 'moment';
import {injectIntl} from 'react-intl';
import CustomScrollDiv from '../scroll-bars/custom_scroll_div';
import Dropdown from '../dropdowns/dropdown';
import Button from '../buttons/button/button';
import TimeRegWSuggestionInput from '../inputs/time-registration-input/time_reg_w_sugestions_input';
import DatePicker from '../date-picker/date_picker_v3';
import Util from '../../util/util';
import CreateTimeRegistrationMutation from '../../../../mutations/create_time_registration_mutation.modern';
import UpdateTimeRegistrationMutation from '../../../../mutations/update_time_registration_mutation.modern';
import {createToast} from '../toasts/another-toast/toaster';
import {formatProjectOption, formatTaskOption} from '../dropdowns/task-dropdown/add_time_entry_data_format';
import {BUTTON_COLOR, BUTTON_STYLE, DATE_PICKER_STYLE} from '../../../../constants';
import {dispatch, EVENT_ID} from '../../../../containers/event_manager';
import ForecastQueryRenderer from '../../../../ForecastQueryRenderer';
import TaskDropdownRelayWrapper, {taskDropdownRelayWrapperQuery} from '../dropdowns/task-dropdown/task_dropdown_relay_wrapper';
import ProjectDropdownRelay from '../dropdowns/project-dropdown-b/Project_dropdown';
import * as tracking from '../../../../tracking';

import {ModalWrapper, DropdownWrapper, DropdownLabel, DropdownLabelWrapper, TabSelectorWrapper, ElemWrapper, ButtonWrapper, TextArea} from '../../../../styles/components/timesheets/add_time_entry_component_styled';
import InlineLoader from '../inline-loader/inline_loader';
import {showModal, MODAL_TYPE} from '../modals/generic_modal_conductor';
import TooltipContainer from '../tooltips/tooltip_container';
import {Dropdown as WCDropdown, SingleText} from 'web-components';
import {cloneDeep} from 'lodash';
const addTimeEntryComponent = ({
	intl: {formatMessage},
	viewer,
	pageSize,
	clearTimer,
	registerTimeClearTimer,
	closeModal,
	updateTimeRegId,
	timerProject,
	timerTask,
	timerIdleTime,
	roundedTimerDuration,
	passedTime,
	passedDate,
	passedNotes,
	selectedPerson,
	weekArray,
	isWeekView,
	isTimepage,
	setShowTimeEntryPortal,
	googleTask,
	source,
	lockedDate,
	passedHarvestTask,
	showFullNotes,
	hasOpportunityAccess,
}) => {
	const notesRef = useRef();
	const today = Moment();
	const [notesIsFocused, setNotesIsFocused] = useState(false);
	const [selectedProject, setSelectedProject] = useState(timerProject || timerIdleTime);
	const [selectedTask, setSelectedTask] = useState(timerTask);
	const [harvestTasks, setHarvestTasks] = useState([]);
	const [harvestLoading, setHarvestLoading] = useState(false);
	const [selectedHarvestTask, setSelectedHarvestTask] = useState(passedHarvestTask ? {value: passedHarvestTask} : null);
	const [selectedUnit4Activity, setSelectedUnit4Activity] = useState(null);
	const [unit4Loading, setUnit4Loading] = useState(false);
	const [unit4Activities, setUnit4Activities] = useState([]);
	const [selectedDate, setSelectedDate] = useState(lockedDate && lockedDate.isSameOrAfter(today, 'day') ? lockedDate.clone().add(1, 'd') : today);
	const [searchValue, setSearchValue] = useState('');
	const [timeInputValue, setTimeInputValue] = useState(roundedTimerDuration * 60 || passedTime * 60); // not the one shown in the input but the one that gonna be sent to the mutation
	const [notesInputValue, setNotesInputValue] = useState(passedNotes ? passedNotes : '');
	const [selectedTab, setSelectedTab] = useState(timerProject ? 'PROJECT' : timerTask || googleTask ? 'TASK' : timerIdleTime ? (timerIdleTime.isInternalTime ? 'INTERNAL' : 'TIMEOFF') : localStorage.getItem('timer-modal-selected-tab') || 'PROJECT');

	useEffect(() => {
		if (lockedDate && lockedDate.isSameOrAfter(selectedDate, 'day')) {
			setSelectedDate(lockedDate.clone().add(1, 'd'));
		}
	}, [lockedDate]);

	let innerRef = null;

	const scrollRef = useRef(null);

	const isFullyLocked = useMemo(() => {
		if (lockedDate && passedDate) {
			return isWeekView ? lockedDate.isSameOrAfter(passedDate.clone().endOf('week'), 'd') : lockedDate.isSameOrAfter(passedDate, 'd');
		}
		return false;
	}, [isWeekView, lockedDate, passedDate]);

	const tooltipProps = isFullyLocked && {infoText: formatMessage({id: 'time-lock.tooltip-date-locked'}), showDelay: 300, tooltipPosition: 'bottom', canBeMiddle: true};

	const lockedDateWithinTheWeek = useMemo(() => {
		if (lockedDate && isWeekView) {
			return lockedDate.isBefore(passedDate.clone().endOf('week'), 'd') && lockedDate.isAfter(passedDate.clone().startOf('week'), 'd');
		}
		return false;
	}, [isWeekView, lockedDate, passedDate]);

	useEffect(() => {
		if (notesIsFocused) {
			scrollRef && scrollRef.current && scrollRef.current.animateScrollTop(1000);
		}
	}, [notesIsFocused]);

	const fetchHarvestTasks = project => {
		//If project dropdown is not empty
		if (project) {
			//If a project is selected, show only tasks that belong to that project
			if (project.projectId && project.harvestProject) {
				if (harvestLoading === true || harvestTasks.length > 0) return;
				setHarvestLoading(true);
				const headers = new Headers();
				headers.append('Content-Type', 'application/json');
				const init = {headers: headers, credentials: 'include'};
				fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'harvest_tasks/' + project.projectId, init)
					.then(result => result.json())
					.then(tasks => {
						setHarvestTasks(tasks);
						setHarvestLoading(false);
					});
			} else {
				setHarvestTasks([]);
				setHarvestLoading(false);
			}
		} else {
			setHarvestTasks([]);
			setHarvestLoading(false);
		}
	};

	const fetchUnit4Activities = project => {
		//If project dropdown is not empty
		if (project) {
			//If a project is selected, show only tasks that belong to that project
			if (project.projectId && project.unit4Project) {
				if (unit4Loading === true || unit4Activities.length > 0) return;
				setUnit4Loading(true);
				const headers = new Headers();
				headers.append('Content-Type', 'application/json');
				const init = {headers: headers, credentials: 'include'};
				fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'unit4_activities/' + project.projectId, init)
					.then(result => result.json())
					.then(activities => {
						setUnit4Activities(activities);
						setUnit4Loading(false);
					});
			} else {
				setUnit4Activities([]);
				setUnit4Loading(false);
			}
		} else {
			setUnit4Activities([]);
			setUnit4Loading(false);
		}
	};

	const handleChangeProjectDropdown = (_, ids) => {
		if (ids.length === 0) {
			setSelectedProject(null);
		} else {
			// Hack to support old code
			const newProject = {
				...viewer.projects.edges.find(project => project.node.id === ids[0]).node,
			};
			newProject.projectId = newProject.id;

			setSelectedProject(newProject);
		}
		setSelectedTask(null);
		setUnit4Activities([]);
		setHarvestTasks([]);
	};

	const handleChangeInternalTimeDropdown = (_, ids) => {
		const idleTime = viewer.company.idleTimes.edges.find(edge => edge.node.id === ids[0]);
		setSelectedProject({
			id: idleTime.node.id,
			value: idleTime.node.id,
			label: idleTime.node.name,
			idleTimeId: idleTime.node.id,
		});
	};

	const handleTaskChange = task => {
		task && task.value ? setSelectedTask(task) : setSelectedTask(null);
		task && task.project ? setSelectedProject(task.project) : void 0;
	};

	const handleHarvestTaskChange = harvestTask => {
		setSelectedHarvestTask(harvestTask);
	};

	const handleUnit4ActivityChange = unit4Activity => {
		setSelectedUnit4Activity(unit4Activity);
	};

	const handleNoteChange = e => {
		setNotesInputValue(e.target.value);
	};

	const handleTabChange = tab => {
		if (tab !== selectedTab) {
			tracking.trackElementClicked('Add-time-section-tab-' + tab);
			setSelectedTab(tab);
			setSelectedProject(tab === 'PROJECT' ? timerProject : null);
			setSelectedTask(tab === 'PROJECT' || tab === 'TASK' ? timerTask : null);
			setSelectedHarvestTask(null);
			setSelectedUnit4Activity(null);
			Util.localStorageSetItem('timer-modal-selected-tab', tab);
		}
	};

	const handleDateSelection = option => {
		if (option.value) {
			setSelectedDate(option.value);
		}
	};

	const onSearchValueChange = searchValue => {
		setSearchValue(searchValue);
	};

	const clearModal = () => {
		//tracking.trackElementClicked('Add-time-section-clear');
		setSelectedProject(null);
		setSelectedTask(null);
		setSelectedHarvestTask(null);
		setHarvestTasks([]);
		setSearchValue('');
		setTimeInputValue('');
		setNotesInputValue('');

		dispatch(EVENT_ID.RESET_INPUT);

		if (setShowTimeEntryPortal) {
			setShowTimeEntryPortal(false);
		}
	};

	// Set selectedDate to either a day in the week if week view, or the passedDate if dayview.
	useEffect(() => {
		// Prioritize setting selected date to a day in the week if weekView is selected

		if (lockedDateWithinTheWeek) {
			//check the first unlockedDay
			let day = null;
			weekArray.forEach(d => {
				if (lockedDate.isBefore(d, 'd') && day === null) {
					day = d;
				}
			});
			setSelectedDate(day);
			return;
		}

		if (isWeekView && weekArray && weekArray.length > 0) {
			if (passedDate) {
				let day = null;
				weekArray.forEach(d => {
					if (passedDate.isSame(d, 'day')) {
						day = d;
					}
				});
				if (day) {
					setSelectedDate(day);
					return;
				}
			}
			const today = Moment();
			let todayInWeek = null;
			weekArray.forEach(weekDay => {
				if (weekDay.isSame(today, 'day')) {
					todayInWeek = weekDay;
				}
			});
			// If today is not in selected week, default to first day of the week (this will be sunday for US).
			setSelectedDate(todayInWeek ? todayInWeek : weekArray[0]);
		} else if (passedDate) {
			setSelectedDate(passedDate);
		}
	}, [passedDate, weekArray]);

	useEffect(() => {
		if (googleTask) {
			const googleProject = formatProjectOption(googleTask.project);
			const googleT = formatTaskOption(googleTask);
			setSelectedProject(googleProject);
			setSelectedTask(googleT);
			innerRef.focus();
		}
	}, [googleTask]);

	useEffect(() => {
		if (passedHarvestTask) {
			fetchHarvestTasks(selectedProject);
		}
	}, []);

	const setSuggestedValueToInput = value => {
		if (isNaN(value)) {
			setTimeInputValue(null);
		} else {
			setTimeInputValue(Util.convertTimeInputToMinutes(value));
		}
	};

	const registerTime = () => {
		const onSuccess = result => {
			const resultType = result.createTimeReg || result.updateTimeReg;
			if (resultType && resultType.errors && resultType.errors.length === 1 && resultType.errors[0] === 'TIME_REGISTRATION_IN_LOCKED_PERIOD') {
				showModal({
					type: MODAL_TYPE.WARNING_DATE_LOCKED,
				});
			} else {
				dispatch(EVENT_ID.TIME_REGISTRATION_MUTATION_SUCCESS, {timeRegisteredInHours: timeInputValue / 60, wasClickEvent: false});
				tracking.trackElementClicked('Add-time-section-add');
				createToast({duration: 5000, message: updateTimeRegId ? formatMessage({id: 'time_page.time_reg_updated'}) : formatMessage({id: 'timer_modal.registered_toast_text'})});
				clearModal();
				if (closeModal) {
					closeModal();
				}
				if (registerTimeClearTimer) {
					registerTimeClearTimer();
				}
			}
		};
		if (!isNaN(timeInputValue) && timeInputValue !== '' && timeInputValue !== null && timeInputValue <= 1440) {
			if (updateTimeRegId) {
				Util.CommitSchedulingModalUpdate(
					UpdateTimeRegistrationMutation,
					{
						id: updateTimeRegId,
						source: source ? source : 'Time-entry-component',
						updateTimeRegLocation: true,
						projectId: selectedProject && selectedProject.projectId ? selectedProject.projectId : null,
						taskId: selectedTask ? selectedTask.value : null,
						idleTimeId: selectedProject && selectedProject.idleTimeId ? selectedProject.idleTimeId : null,
						minutesRegistered: timeInputValue,
						day: selectedDate.date(),
						month: selectedDate.month() + 1,
						year: selectedDate.year(),
						harvestTaskId: selectedHarvestTask ? selectedHarvestTask.value : undefined,
						unit4ActivityId: selectedUnit4Activity ? selectedUnit4Activity.value : undefined,
						unit4ActivityName: selectedUnit4Activity ? selectedUnit4Activity.label : undefined,
						notes: notesInputValue !== '' ? notesInputValue : null,
						newFormat: true,
					},
					onSuccess
				);
			} else {
				Util.CommitSchedulingModalUpdate(
					CreateTimeRegistrationMutation,
					{
						viewer: viewer,
						source: source ? source : 'Time-entry-component',
						projectId: selectedProject && selectedProject.projectId ? selectedProject.projectId : null,
						taskId: selectedTask ? selectedTask.value : null,
						subTask: selectedTask ? !!selectedTask.parentTaskId : null,
						idleTimeId: selectedProject && selectedProject.idleTimeId ? selectedProject.idleTimeId : null,
						minutesRegistered: timeInputValue,
						day: selectedDate.date(),
						month: selectedDate.month() + 1,
						year: selectedDate.year(),
						personId: selectedPerson ? selectedPerson.id : viewer.actualPersonId,
						harvestTaskId: selectedHarvestTask ? selectedHarvestTask.value : undefined,
						unit4ActivityId: selectedUnit4Activity ? selectedUnit4Activity.value : undefined,
						unit4ActivityName: selectedUnit4Activity ? selectedUnit4Activity.label : undefined,
						notes: notesInputValue !== '' ? notesInputValue : null,
						newFormat: true,
					},
					onSuccess
				);
			}
		} else {
			innerRef.focus();
		}
	};

	// function for the new internal time dropdown
	/**
	 *
	 * @param {"internal" | "timeOff"} type
	 */
	const getIdleTimeOptions = type => {
		const options = [];
		const sortedIdleTimes = cloneDeep(viewer.company.idleTimes.edges).sort((a, b) => Util.sortAlphabetically(a.node.name, b.node.name));
		for (const idleTime of sortedIdleTimes) {
			const getItem = () => {
				return (
					<SingleText cy={`option-${idleTime.node.name}`} key={idleTime.node.id} value={idleTime.node.id} searchString={idleTime.node.name}>
						{idleTime.node.name}
					</SingleText>
				);
			};

			if (!idleTime.node.disabled && type === 'internal' && idleTime.node.isInternalTime) {
				options.push(getItem());
			} else if (!idleTime.node.disabled && type === 'timeOff' && !idleTime.node.isInternalTime) {
				options.push(getItem());
			}
		}
		return options;
	};

	const harvestTaskOptions = harvestTasks
		? harvestTasks.map(harvestTask => {
				return {value: harvestTask.id, label: harvestTask.name};
		  })
		: [];

	const unit4ActivityOptions = unit4Activities
		? unit4Activities.map(unit4Activity => {
				return {value: unit4Activity.id, label: unit4Activity.name};
		  })
		: [];

	const weekDayOptions = weekArray
		? weekArray.map(weekDay => {
				return {value: weekDay, label: Util.upperCaseFirst(weekDay.format('dddd')) + ' (' + weekDay.format('l') + ')', disabled: lockedDate && lockedDate.isSameOrAfter(weekDay, 'day')};
		  })
		: [];

	const content = (
		<>
			<TabSelectorWrapper isTimepage={isTimepage}>
				<Button
					id={'add-time-view-task'}
					cy={'add-time-view-task'}
					text={formatMessage({id: 'common.task'})}
					buttonStyle={BUTTON_STYLE.FILLED}
					colorTheme={selectedTab === 'PROJECT' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
					onClick={handleTabChange.bind(this, 'PROJECT')}
					isDisabled={isFullyLocked || passedHarvestTask}
				/>
				<Button
					id={'add-time-view-internal'}
					cy={'add-time-view-internal'}
					text={formatMessage({id: 'common.internal_time'})}
					buttonStyle={BUTTON_STYLE.FILLED}
					colorTheme={selectedTab === 'INTERNAL' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
					onClick={handleTabChange.bind(this, 'INTERNAL')}
					userpilot={'timesheets-internal-time-button'}
					isDisabled={isFullyLocked || passedHarvestTask}
				/>
				<Button
					id={'add-time-view-time-off'}
					cy={'add-time-view-time-off'}
					text={formatMessage({id: 'common.time_off'})}
					buttonStyle={BUTTON_STYLE.FILLED}
					colorTheme={selectedTab === 'TIMEOFF' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
					onClick={handleTabChange.bind(this, 'TIMEOFF')}
					userpilot={'timesheets-time-off-button'}
					isDisabled={isFullyLocked || passedHarvestTask}
				/>
			</TabSelectorWrapper>

			{selectedTab === 'PROJECT' ? (
				<DropdownWrapper isTimepage={isTimepage}>
					<DropdownLabelWrapper>
						<DropdownLabel>{formatMessage({id: 'common.project'})}</DropdownLabel>

						<TooltipContainer {...tooltipProps}>
							<ProjectDropdownRelay
								showHalted={false}
								showDone={false}
								projects={viewer.projects.edges}
								isClearable
								optionsName={formatMessage({id: 'common.projects'})}
								selectedItems={selectedProject ? [selectedProject.projectId] : []}
								onRemove={handleChangeProjectDropdown}
								onSelect={handleChangeProjectDropdown}
								groupByStatus
								showRunning
								showPlanning
								showOpportunity={hasOpportunityAccess}
								showSecondaryIcon
								usePortal
								isHarvestUser={selectedPerson ? selectedPerson.harvestUser : viewer.harvestUser}
								maxHeight={255}
								name={formatMessage({id: 'common.all_projects'})}
								userpilot="timesheets-select-project"
								disabled={isFullyLocked || passedHarvestTask}
								cy="time-entry-project-dropdown"
							/>
						</TooltipContainer>
					</DropdownLabelWrapper>
				</DropdownWrapper>
			) : null}
			<DropdownWrapper isTimepage={isTimepage}>
				{selectedTab === 'PROJECT' || selectedTab === 'TASK' ? (
					<DropdownLabelWrapper>
						<DropdownLabel>{formatMessage({id: 'common.task'})}</DropdownLabel>
						<ForecastQueryRenderer
							key="query-render-taskDropdownRelayWrapper"
							componentName="task_dropdown"
							query={taskDropdownRelayWrapperQuery}
							showLoader={true}
							customLoader={() => <InlineLoader />}
							variables={{
								pageSize: pageSize,
								modalSearchQuery: {filters: []},
								sortValue: 'project-id',
							}}
							render={(relayProps, retry) => {
								return (
									<TaskDropdownRelayWrapper
										{...relayProps}
										pageSize={pageSize}
										selectedProject={selectedProject}
										searchValue={searchValue}
										retry={retry}
										placeholder={selectedProject && selectedProject.label !== '' ? formatMessage({id: 'common.tasks_in_project'}, {project: selectedProject.label}) : formatMessage({id: 'common.all_tasks'})}
										expandedPlaceholder={formatMessage({id: 'common.type_to_search'})}
										externalSearch={onSearchValueChange}
										value={selectedTask && !isFullyLocked ? selectedTask.label : ''}
										onChange={handleTaskChange}
										isHarvestUser={selectedPerson ? selectedPerson.harvestUser : viewer.harvestUser}
										closeOnScroll={isTimepage}
										projectIdLabel={
											selectedTask
												? {
														companyProjectId: selectedTask.companyProjectId,
														name: selectedTask.name,
														projectColor: selectedTask.projectColor,
												  }
												: null
										}
										userpilot={'timesheets-select-task'}
										disabled={isFullyLocked}
									/>
								);
							}}
						/>
					</DropdownLabelWrapper>
				) : selectedTab === 'INTERNAL' ? (
					<WCDropdown
						cy="time-internal-select-dropdown"
						maxHeight={250}
						name={formatMessage({id: 'overview_time.select_internal'})}
						onSelect={handleChangeInternalTimeDropdown}
						disabled={isFullyLocked}
						selectedItems={!!selectedProject ? [selectedProject.id] : []}
					>
						{getIdleTimeOptions('internal')}
					</WCDropdown>
				) : (
					<WCDropdown maxHeight={250} name={formatMessage({id: 'overview_time.select_time-off'})} onSelect={handleChangeInternalTimeDropdown} disabled={isFullyLocked} selectedItems={!!selectedProject ? [selectedProject.id] : []}>
						{getIdleTimeOptions('timeOff')}
					</WCDropdown>
				)}
			</DropdownWrapper>
			{selectedProject && selectedProject.harvestProject && (selectedPerson ? selectedPerson.harvestUser : viewer.harvestUser) && viewer.company.harvestEnabled ? (
				<DropdownWrapper isTimepage={isTimepage}>
					<DropdownLabelWrapper>
						<Dropdown
							id={'time-harvest-dropdown'}
							options={harvestTaskOptions}
							onChange={handleHarvestTaskChange}
							value={selectedHarvestTask ? selectedHarvestTask.value : ''}
							label={formatMessage({id: 'card_modal.harvest_task'})}
							multi={false}
							clearable={true}
							focusOnClick={true}
							customHeight={30}
							placeholder={harvestLoading ? formatMessage({id: 'common.loading'}) : formatMessage({id: 'card_modal.harvest_task_placeholder'})}
							maxHeight={245}
							onClick={fetchHarvestTasks.bind(this, selectedProject)}
							integrationDropdown={true}
							integrationLoading={harvestLoading}
							integrationRetryToFetch={fetchHarvestTasks.bind(this, selectedProject)}
							disabled={isFullyLocked}
							tooltipProps={tooltipProps}
						/>
					</DropdownLabelWrapper>
				</DropdownWrapper>
			) : null}
			{selectedProject && selectedProject.unit4Project && selectedProject.unit4Project.activitiesEnabled && (selectedPerson ? selectedPerson.unit4User : viewer.unit4User) && viewer.company.unit4Enabled ? (
				<DropdownWrapper isTimepage={isTimepage}>
					<DropdownLabelWrapper>
						<Dropdown
							id={'time-unit4-dropdown'}
							options={unit4ActivityOptions}
							onChange={handleUnit4ActivityChange}
							value={selectedUnit4Activity ? selectedUnit4Activity.value : ''}
							label={formatMessage({id: 'integrations.unit4_activity'})}
							multi={false}
							clearable={true}
							focusOnClick={true}
							customHeight={30}
							placeholder={formatMessage({id: 'integrations.unit4_activity_placeholder'})}
							maxHeight={245}
							onClick={fetchUnit4Activities.bind(this, selectedProject)}
							integrationDropdown={true}
							integrationLoading={unit4Loading}
							integrationRetryToFetch={fetchUnit4Activities.bind(this, selectedProject)}
							disabled={isFullyLocked}
							tooltipProps={tooltipProps}
						/>
					</DropdownLabelWrapper>
				</DropdownWrapper>
			) : null}
			<ElemWrapper isTimepage={isTimepage}>
				<TimeRegWSuggestionInput
					id={'time-add-hours-input'}
					initialValue={roundedTimerDuration || passedTime}
					onInputChange={value => {
						setSuggestedValueToInput(value);
					}}
					placeholder={formatMessage({id: 'hours_input.placeholder'})}
					clearable={true}
					date={selectedDate}
					task={selectedTask}
					idleTime={selectedProject && selectedProject.idleTimeId ? selectedProject : null}
					viewer={viewer}
					changeOnlyOnValid={false}
					innerRef={div => (innerRef = div)}
					userpilot={'timesheets-hours-input'}
					disabled={isFullyLocked}
					infoText={isFullyLocked && formatMessage({id: 'time-lock.tooltip-date-locked'})}
				/>
			</ElemWrapper>
			{!isTimepage ? (
				<ElemWrapper isTimepage={isTimepage}>
					<DropdownLabel>{formatMessage({id: 'common.date'})}</DropdownLabel>
					<TooltipContainer {...tooltipProps}>
						<DatePicker
							startDate={selectedDate}
							handleDateRangeChange={setSelectedDate}
							datePickerStyle={DATE_PICKER_STYLE.STANDARD}
							isSingleDatePicker={true}
							disabled={isFullyLocked}
							startDateLimite={lockedDate && lockedDate.clone().add(1, 'd')}
						/>
					</TooltipContainer>
				</ElemWrapper>
			) : isWeekView && weekArray.length > 0 ? (
				<ElemWrapper isTimepage={isTimepage}>
					<DropdownLabel>{formatMessage({id: 'common.select_day'})}</DropdownLabel>
					{<Dropdown customHeight={30} onChange={handleDateSelection} options={weekDayOptions} value={selectedDate} focusOnClick={true} placeholder={'Select day'} hideLabel={true} disabled={isFullyLocked} tooltipProps={tooltipProps} />}
				</ElemWrapper>
			) : null}
			<ElemWrapper className="notes-wrapper" isTimepage={isTimepage}>
				<DropdownLabel className="card-select-label">{formatMessage({id: 'common.notes'})}</DropdownLabel>
				<TooltipContainer {...tooltipProps}>
					<TextArea
						ref={notesRef}
						onBlur={() => setNotesIsFocused(false)}
						onFocus={() => {
							setNotesIsFocused(true);
						}}
						disabled={isFullyLocked}
						maxLength={viewer.company.characterLimit > -1 ? viewer.company.characterLimit : 999}
						className={'foldout'}
						value={notesInputValue}
						rows={notesIsFocused || showFullNotes ? 3 : 1}
						onChange={handleNoteChange}
						placeholder={formatMessage({id: 'common.enter_notes'})}
					/>
				</TooltipContainer>
			</ElemWrapper>
		</>
	);

	// Time page is in calendarView if on timePage and function to hide portal is not passed
	const isCalendarView = isTimepage && !setShowTimeEntryPortal;

	return (
		<ModalWrapper isTimepage={isTimepage} isCalendarView={isCalendarView} data-cy={'add-time-entry-component'}>
			{isCalendarView ? <CustomScrollDiv ref={scrollRef}>{content}</CustomScrollDiv> : content}

			<ButtonWrapper isTimepage={isTimepage}>
				{closeModal ? (
					<Button
						text={!roundedTimerDuration || !viewer.timerStartDate ? formatMessage({id: 'common.cancel'}) : formatMessage({id: 'timer_modal.reset_timer'})}
						buttonStyle={BUTTON_STYLE.FILLED}
						colorTheme={BUTTON_COLOR.WHITE}
						onClick={!roundedTimerDuration || !viewer.timerStartDate ? closeModal.bind(this) : clearTimer.bind(this, true)}
					/>
				) : setShowTimeEntryPortal ? (
					<Button text={formatMessage({id: 'common.filter-close'})} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.WHITE} onClick={clearModal.bind(this)} />
				) : null}
				<Button
					isDisabled={
						isFullyLocked ||
						timeInputValue == null ||
						(!selectedProject && !selectedTask) ||
						(selectedProject && selectedProject.harvestProject && (selectedPerson ? selectedPerson.harvestUser : viewer.harvestUser) && viewer.company.harvestEnabled && !selectedHarvestTask)
					}
					text={updateTimeRegId ? formatMessage({id: 'common.update'}) : formatMessage({id: 'common.add'})}
					cy={'log-time-btn'}
					buttonStyle={BUTTON_STYLE.FILLED}
					colorTheme={BUTTON_COLOR.GREEN}
					onClick={registerTime.bind(this)}
					userpilot={'timesheets-add-time'}
					tooltipProps={tooltipProps}
				/>
			</ButtonWrapper>
		</ModalWrapper>
	);
};

export default injectIntl(addTimeEntryComponent);
